import { ADMIN } from '@/utils/roles'
import { DISCOUNT_SETUP_VIEW, TAX_VIEW, REWARDS_DISCOUNT } from '../../utils/permissions'
export default [
  {
    path: '/settings/stock-photo',
    name: 'stock-images-gallery',
    component: () => import('@/views/settings/StockPhotoGallery.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Stock-Photo',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Settings' }, { title: 'Stock Images Gallery', active: true }],
      roles: [ADMIN]
    }
  },
  {
    path: '/settings/tax-list',
    name: 'text-list',
    component: () => import('@/views/settings/TaxSetup.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Tax-setting',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Product Tax-setting' }, { title: 'Tax-setting', active: true }],
      permissions: [TAX_VIEW]
    }
  },
  {
    path: '/settings/spf-records',
    name: 'spf-records',
    component: () => import('@/views/settings/SPFRecordReceipt.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'SPF-Records',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'SPF Record-Receipt', active: true }
      ],
      permissions: [ADMIN]
    }
  },
  {
    path: '/settings/discount-setup',
    name: 'discount-setup',
    component: () => import('@/views/settings/DiscountSetUp.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Discount-Setup',
      breadcrumb: [
        { title: 'Discount-Setup', url: 'discount-setup' },
        { title: 'Discount Setup', active: true }
      ],
      permissions: [DISCOUNT_SETUP_VIEW]
    }
  },
  {
    path: '/settings/reward-setup',
    name: 'reward-setup',
    component: () => import('@/views/settings/RewardSetUp.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Reward-Setup',
      breadcrumb: [
        { title: 'Reward-Setup', url: 'Reward-setup' },
        { title: 'Reward Setup', active: true }
      ],
      permissions: [REWARDS_DISCOUNT]
    }
  },
  {
    path: '/settings/terms-condition',
    name: 'terms-condition',
    component: () => import('@/views/settings/TermsCondition.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Terms Condition',
      breadcrumb: [
        { title: 'Terms-Condition', url: 'Terms-Condition' },
        { title: 'Terms Condition', active: true }
      ],
      permissions: [DISCOUNT_SETUP_VIEW]
    }
  }
]
